module.exports = __webpack_public_path__ + "img/Kofferraumparty.01b7803a.svg";